type DestinationGateParams = {
  isHall?: string | null;
  orderType?: string | null;
  branchId?: string | null;
  geolocation?: string | null;
};

/** Returns true when Add should open the map instead of adding to cart. */
export function needsDestinationSelection({
  isHall,
  orderType,
  branchId,
  geolocation,
}: DestinationGateParams): boolean {
  if (isHall) return false;

  return (
    (orderType === 'self-pickup' && !branchId) ||
    (orderType === 'delivery' && geolocation !== 'accepted')
  );
}
